import React, { FC } from "react";
import { Stack } from "@mui/material";
import PageHeading from "../Common/PageHeading/PageHeading";
import PageContent from "../Common/PageContent/PageContent";
import ServiceChatBookingForm from "../OurServices/ServiceChatBookingForm";

export const Contactus: FC = () => {
  return (
    <section
      style={{
        background: "#ffffff"
      }}
    >
      <PageHeading titleText="Contact us" />
      <PageContent styles={{ backgroundColor: "#ffffff" }}>
        <Stack>
          <ServiceChatBookingForm />
        </Stack>
      </PageContent>
    </section>
  );
};

export default Contactus;
